<div class="sivu">
  <input #tiedostoInput type="file" multiple [accept]="hyvaksytytTiedostotyypit" class="hidden" (change)="tiedostotValittu($event)" />

  @if (!valittuSetti()) {
    <div>
      <div class="info-block">
        <p class="info-block__title">Tositteen luvun testisetit</p>
        <p class="setti-kuvaus">
          Testisetti on kokoelma tositteita, joille on syötetty oikeat tiedot käsin. Tositteita lisätään settiin asiakkaan Selaa tositteita -näkymästä valitsemalla kortit ja painamalla "Lisää valitut testisettiin",
          tai lataamalla tiedostoja (jpg, png, webp, pdf) alla olevalla painikkeella. Oikeita tietoja ei koskaan johdeta mallin omasta tuloksesta.
        </p>
      </div>

      <div class="uusi-setti-rivi">
        <mat-form-field class="uusi-setti-nimi-kentta">
          <mat-label>Uuden testisetin nimi</mat-label>
          <input matInput [formField]="uusiSettiNimiKentta" />
        </mat-form-field>
        <app-primary-button (click)="luoSetti()" [disabled]="luoSettiKaynnissa() || !uusiSettiNimiKentta().value().trim()" actionId="Luo tositteen luvun testisetti">
          @if (luoSettiKaynnissa()) {
            <mat-spinner diameter="18" class="nappi-spinner"></mat-spinner>
          }
          Luo setti
        </app-primary-button>
        <app-button (click)="avaaTiedostovalitsin()" matIcon="upload_file" actionId="Lataa tositteita tositteen luvun testisettiin">Lataa tositteita</app-button>
      </div>

      @if (setitLataa()) {
        <mat-spinner diameter="24"></mat-spinner>
      } @else if (!setit().length) {
        <p class="tyhja-viesti">Ei vielä settejä — luo ensimmäinen yllä.</p>
      } @else {
        <table class="setit-taulukko">
          <tr class="setit-otsikkorivi">
            <th class="setit-th">Nimi</th>
            <th class="setit-th--oikea">Tositteita</th>
            <th class="setit-th">Luotu</th>
            <th class="setit-solu"></th>
          </tr>
          @for (s of setit(); track s.avain) {
            <tr class="setit-rivi">
              <td class="setit-solu">
                <app-button (click)="avaaSetti(s)" styles="padding-left: 0" actionId="Avaa tositteen luvun testisetti">
                  <strong>{{ s.nimi }}</strong>
                </app-button>
              </td>
              <td class="setit-solu--oikea">{{ s.testitapausLkm }}</td>
              <td class="setit-solu">{{ s.luotu | date: 'dd.MM.yyyy HH:mm' }}</td>
              <td class="setit-solu--oikea">
                <app-icon-button (click)="poistaSetti(s)" matIcon="delete" matTooltip="Poista" actionId="Poista tositteen luvun testisetti"></app-icon-button>
              </td>
            </tr>
          }
        </table>
      }
    </div>
  } @else {
    <div>
      <div class="setti-header-rivi">
        <app-icon-button (click)="suljeSetti()" matIcon="arrow_back" matTooltip="Takaisin" actionId="Sulje tositteen luvun testisetti"></app-icon-button>
        <h3 class="setti-otsikko-h3">{{ valittuSetti().nimi }}</h3>
        <span class="tayte"></span>
        <app-button (click)="avaaTiedostovalitsin()" matIcon="upload_file" actionId="Lataa tositteita avattuun testisettiin">Lataa tositteita</app-button>
        <app-button (click)="paivitaToimittajaRekisterit()" [disabled]="paivitetaanRekisterit() || !testitapaukset().length" matIcon="sync" actionId="Päivitä setin toimittajarekisterit">
          @if (paivitetaanRekisterit()) {
            <mat-spinner diameter="18" class="nappi-spinner"></mat-spinner>
          }
          Päivitä toimittajarekisterit
        </app-button>
      </div>

      <div class="tosite-rivi">
        <div #tositeContainer class="tosite-esikatselu-container">
          @if (!valittuTestitapaus()) {
            <div class="tyhja-viesti-keskitetty">Valitse tosite nähdäksesi sen kuvat</div>
          } @else if (valittuTestitapaus().lahde === 'ladattu') {
            @if (ladatutEsikatselut() === null) {
              <mat-spinner diameter="24" class="esikatselu-spinner"></mat-spinner>
            } @else if (!ladatutEsikatselut().length) {
              <div class="tyhja-viesti-keskitetty">Ladattua tiedostoa ei löydy: {{ valittuTestitapaus().nimi }}</div>
            } @else {
              @for (tiedosto of ladatutEsikatselut(); track tiedosto.nimi) {
                @if (tiedosto.onPdf) {
                  <div app-pdf-viewer [url]="tiedosto.url"></div>
                } @else {
                  <img [src]="tiedosto.url" [alt]="tiedosto.nimi" class="esikatselu-kuva" />
                }
              }
            }
          } @else if (naytettavatTositteetJaSivut() === null) {
            <mat-spinner diameter="24" class="esikatselu-spinner"></mat-spinner>
          } @else if (!naytettavatTositteetJaSivut().length) {
            <div class="tyhja-viesti-keskitetty">Tositetta ei löydy lemonatorista</div>
          } @else {
            <div app-kirjanpito-tosite-naytto [piilotaYlaControllit]="true" [naytaRuksi]="false" [scrollContainerRef]="tositeContainerRef" [naytettavaKirjausObservable]="tyhjaKirjausObservable" [naytettavatTositteetJaSivut]="naytettavatTositteetJaSivut()"></div>
          }
        </div>

        <div class="testitapaukset-lohko">
          <h4 class="testitapaukset-otsikko">Setissä olevat tositteet ({{ testitapaukset().length }})</h4>
          <div class="testitapaukset-scroll">
            @if (testitapauksetLataa()) {
              <mat-spinner diameter="24"></mat-spinner>
            } @else if (!testitapaukset().length) {
              <p class="tyhja-viesti">Ei vielä tositteita — lisää niitä asiakkaan Selaa tositteita -näkymästä tai lataa tiedostoja.</p>
            }
            @for (rivi of testitapaukset(); track rivi.avain) {
              <div class="testitapaus-rivi" [class.valittu]="valittuTestitapaus()?.avain === rivi.avain" (click)="valitseTestitapaus(rivi)">
                <div class="testitapaus-tiedot">
                  <div>
                    <span class="lahde-merkki">{{ rivi.lahde === 'ladattu' ? 'Ladattu' : 'Lemonaid' }}</span>
                    <strong>{{ rivi.nimi }}</strong>
                  </div>
                  <div>{{ metatiedotTiivistelma(rivi) }}</div>
                  <div class="testitapaus-meta">Viitepäivä {{ rivi.viitepaiva }}</div>
                  @if (rivi.lahde === 'lemonaid') {
                    <div class="testitapaus-meta">Toimittajarekisteri: {{ rivi.toimittajaRekisteri.length }} toimittajaa, päivitetty {{ rivi.toimittajaRekisteriPaivitetty | date: 'dd.MM.yyyy HH:mm' }}</div>
                    @if (rekisteristaPuuttuuYtunnukset(rivi)) {
                      <div class="vihje-rivi">Rekisterissä ei ole y-tunnuksia. Päivitä rekisteri, jotta webin ja mobiilin luku voi täsmätä toimittajan tunnuksella.</div>
                    }
                  }

                  @if (valittuTestitapaus()?.avain === rivi.avain) {
                    <form class="metatiedot-lomake" (click)="$event.stopPropagation()">
                      <app-metatiedot-form [form]="metatiedotForm" [naytaToimittajaValinta]="rivi.lahde === 'lemonaid'" [toimittajaRekisteri]="rivi.toimittajaRekisteri" businessIdTyhjaHint="Tyhjä = mallilta odotetaan null" paivamaaraLabel="Päivämäärä (YYYY-MM-DD, valinnainen)" summaLabel="Summa (valinnainen)"></app-metatiedot-form>
                      <div class="vihje">Pisteytyksessä odotetaan: {{ odotettuToimittajaTeksti() }}</div>
                      <mat-form-field class="viitepaiva-kentta" subscriptSizing="dynamic">
                        <mat-label>Viitepäivä (YYYY-MM-DD)</mat-label>
                        <input matInput [formField]="viitepaivaKentta" placeholder="2026-01-31" />
                        <mat-hint>Webin ja mobiilin luvun "tänään". Ei vaikuta lemonatorin lukuun.</mat-hint>
                      </mat-form-field>

                      @if (rivi.tositteenTiedot) {
                        <div class="viiteblokki">
                          <div class="viiteblokki-otsikko">Tositteen tiedot lemonaidissa lisäyshetkellä (viitteeksi)</div>
                          <table class="viite-taulukko">
                            <tr>
                              <td class="viite-otsikko">Toimittaja</td>
                              <td class="viite-arvo">{{ rivi.tositteenTiedot.toimittajaNimi ?? (rivi.tositteenTiedot.toimittajaAvain ? rivi.tositteenTiedot.toimittajaAvain + ' (ei rekisterissä)' : '—') }}</td>
                              <td><app-button (click)="kopioiViitetiedosta('toimittaja')" [disabled]="!rivi.tositteenTiedot.toimittajaNimi" actionId="Kopioi viitetiedon toimittaja (setti)">Kopioi</app-button></td>
                            </tr>
                            <tr>
                              <td class="viite-otsikko">Tunniste</td>
                              <td class="viite-arvo">{{ rivi.tositteenTiedot.toimittajaTunniste ?? '—' }}</td>
                              <td><app-button (click)="kopioiViitetiedosta('businessId')" [disabled]="!rivi.tositteenTiedot.toimittajaTunniste" actionId="Kopioi viitetiedon tunniste (setti)">Kopioi</app-button></td>
                            </tr>
                            <tr>
                              <td class="viite-otsikko">Päivämäärä</td>
                              <td class="viite-arvo">{{ rivi.tositteenTiedot.paivamaara ?? '—' }}</td>
                              <td><app-button (click)="kopioiViitetiedosta('paivamaara')" [disabled]="!rivi.tositteenTiedot.paivamaara" actionId="Kopioi viitetiedon päivämäärä (setti)">Kopioi</app-button></td>
                            </tr>
                            <tr>
                              <td class="viite-otsikko">Summa</td>
                              <td class="viite-arvo">{{ rivi.tositteenTiedot.summa !== null ? (rivi.tositteenTiedot.summa | number: '1.2-2') + ' €' : '—' }}</td>
                              <td><app-button (click)="kopioiViitetiedosta('summa')" [disabled]="rivi.tositteenTiedot.summa === null" actionId="Kopioi viitetiedon summa (setti)">Kopioi</app-button></td>
                            </tr>
                          </table>
                        </div>
                      }

                      <div class="metatiedot-toiminnot">
                        <app-primary-button (click)="tallennaMetatiedot()" [disabled]="tallennetaan() || !onMuutoksia" actionId="Tallenna tositteen metatiedot" [actionContext]="[metatiedotForm.value, viitepaivaKentta().value()]">
                          @if (tallennetaan()) {
                            <mat-spinner diameter="18" class="nappi-spinner"></mat-spinner>
                          }
                          Tallenna metatiedot
                        </app-primary-button>
                        <app-button (click)="peruMuutokset()" [disabled]="!onMuutoksia" actionId="Peru tositteen metatietojen muutokset">Peru</app-button>
                        <span class="tayte"></span>
                        @if (rivi.lahde === 'lemonaid') {
                          <app-button (click)="paivitaToimittajaRekisterit(rivi)" [disabled]="paivitetaanRekisterit()" matIcon="sync" actionId="Päivitä tositteen toimittajarekisteri">Päivitä rekisteri</app-button>
                        }
                      </div>
                    </form>
                  }
                </div>
                <app-icon-button (click)="$event.stopPropagation(); poistaTestitapaus(rivi)" [disabled]="poistetaan().has(rivi.avain)" matTooltip="Poista setistä" actionId="Poista tosite testisetistä">
                  @if (poistetaan().has(rivi.avain)) {
                    <mat-spinner diameter="18"></mat-spinner>
                  } @else {
                    <mat-icon>delete</mat-icon>
                  }
                </app-icon-button>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>
